import React, { ReactNode } from 'react';
import { observer } from 'mobx-react-lite';

import { ProductKit } from '../../model/ProductKit';
import './KitSlider.scss';
import { MoneyDisplay } from '../../util-starter-kit/MoneyDisplay';

interface CardHeaderProps {
  isSelected: boolean;
  onClick: () => void;
  alwaysPrimary?: boolean;
  children: ReactNode;
  showCheckbox?: boolean;
}

export const CardHeader = observer<CardHeaderProps>(function CardHeader({
  isSelected,
  onClick,
  alwaysPrimary = false,
  children,
  showCheckbox = true
}) {
  return (
    <div
      onClick={onClick}
      className={`text-left ${isSelected || alwaysPrimary ? 'bg-primary' : 'bg-secondary'} slider-card-header`}
    >
      <div className="container-checkbox kit-grid-item mt-2 ml-2 mb-2">
        {showCheckbox && <input type="checkbox" className="mt-2 mr-2" readOnly checked={isSelected} />}
        <span className="checkmark" />
        {children}
      </div>
    </div>
  );
});

interface StarterKitCardHeaderProps {
  kit: ProductKit;
  showCheckbox?: boolean;
  store: any;
}

export const StarterKitPriceCardHeader = observer<StarterKitCardHeaderProps>(function ({ kit, store }) {
  const checked = store.selectedKit === kit;
  return (
    <CardHeader onClick={() => store.choseKit(kit)} isSelected={checked}>
      <span className="text-right text-white pr-2">
        <MoneyDisplay price={kit.price} />
      </span>
    </CardHeader>
  );
});
